import { Form } from "antd";
import styles from "./CreateNewCustomer.module.css";
import {
  AntdDropdown,
  AntdInput,
  AntdSubmit,
  InputFielsAntd,
} from "../../../components";
import minusIcon from "../../../assets/minusIcon.png";
import plusIcon from "../../../assets/plusIcon.png";
import { useEffect, useRef, useState } from "react";
import AlertAction from "../../../store/Actions/AlertActions";
import { useDispatch, useSelector } from "react-redux";
import CustomerMiddleware from "../../../store/Middlewares/CustomerMiddlewares";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PhoneInput from "react-phone-number-input/input";
import CompanyMiddleware from "../../../store/Middlewares/CompanyMiddleware";
const CreateNewCustomer = () => {
  const [search, setSearch] = useState("");
  const [CompanyList, setCompanyList] = useState([]);
  const [company, setcompany] = useState([]);
  const [companyDetails, setCompanyDetails] = useState();
  const phoneFormat = (text) => {

    var cleaned = ("" + text).replace(/\D/g, "");
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

    if (match) {
      var intlCode = match[1] ? "+1 " : "",
        number = [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join(
          ""
        );
      return number;
    }
    return text;
  }
  console.log("companyDetails", companyDetails);
  useEffect(() => {
    // getAllCompany()
    getLanguage();
    getCompany();
  }, []);

  // const getAllCompany = () => {
  //   let arr = []
  //   for(let i = 0; i < CompanyList?.length ; i++ ){
  //     arr.push({value: CompanyList?.[i]?.id, option: CompanyList?.[i]?.name})
  //   }
  //   setcompany(arr)
  // }

  const getCompany = () => {
    dispatch(CompanyMiddleware.getCompanyForCustomer())
      .then((data) => {
        console.log("==========>", data?.data);
        let arr = [];
        for (let i = 0; i < data?.data?.length; i++) {
          arr.push({
            value: data?.data?.[i]?.id,
            option: data?.data?.[i]?.name,
          });
        }

        setcompany(arr);
        setCompanyList(data?.data)
      })
      .catch((err) => console.log(err));
  };
  const selectCompDetails = () => {

  }
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [CustomerName, setCustomerName] = useState("");
  const [LastName, setLastName] = useState("");
  const [Email, setEmail] = useState("");
  const [ContactNumber, setContactNumber] = useState("");
  const [Street, setStreet] = useState("");
  const [State, setState] = useState("");
  const [ZipCode, setZipCode] = useState("");
  const [MultipleAddress, setMultipleAddress] = useState([]);
  const [Refresh, setRefresh] = useState(false);
  const StreetRef = useRef(null);
  const StateRef = useRef(null);
  const ZipCodeRef = useRef(null);
  let ref = useRef();
  const [selectedCompanyID, setselectedCompanyID] = useState(null);
  const getLanguage = async () => {
    try {
      const language = localStorage.getItem("@selectedLanguage");
      i18n.changeLanguage(language);
    } catch (e) {
      console.log(e);
    }
  };

  // const onPressAddAddress = () => {
  //   if (!Street || !State || !ZipCode) {
  //     dispatch(
  //       AlertAction.ShowAlert({
  //         type: "error",
  //         message: "Address field are required!",
  //       })
  //     );
  //     // Alert.alert('Note', 'Address field are required!')
  //   } else {
  //     MultipleAddress.push({ Street: Street, State: State, ZipCode: ZipCode });
  //     setStreet("");
  //     setState("");
  //     setZipCode("");

  //     ref.current.value = "";
  //     setRefresh(!Refresh);
  //   }
  // };
  const onFindCompany = (id) => {
    setselectedCompanyID(id)
    CompanyList?.findIndex((item) => {
      if (item?.id == id) {
        setCompanyDetails(item)
      }
    })
  }
  const onPressCreateCustomer = () => {
    console.log("onPressCreateCustomer");
    if (!CustomerName || !LastName || !Email || !ContactNumber) {
      dispatch(
        AlertAction.ShowAlert({
          type: "error",
          message: "All fields are required!",
        })
      );
      // Alert.alert('Note', 'All field are required!')
    } else if (
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(Email) == false
    ) {
      dispatch(
        AlertAction.ShowAlert({
          type: "error",
          message: "Email format is not valid..",
        })
      );
      // Alert.alert("Note", "Email format is not valid..")
    }
    //  else if (MultipleAddress.length == 0 && (!Street || !State || !ZipCode)) {
    //   dispatch(
    //     AlertAction.ShowAlert({
    //       type: "error",
    //       message: "Address field are required!",
    //     })
    //   );
    //   // Alert.alert('Note', 'Address field are required!')
    // } 
    else {
      // if (MultipleAddress.length == 0 && (Street || State || ZipCode)) {
      //   MultipleAddress.push({
      //     Street: Street,
      //     State: State,
      //     ZipCode: ZipCode,
      //   });
      //   setRefresh(!Refresh)
      // } else if (Street || State || ZipCode) {
      //   MultipleAddress.push({
      //     Street: Street,
      //     State: State,
      //     ZipCode: ZipCode,
      //   });
      //   setRefresh(!Refresh)
      // }
      let data = {
        Firstname: CustomerName,
        Lastname: LastName,
        Email: Email,
        ContactNumber: ContactNumber,
        company_id: selectedCompanyID,
        // MultipleAddress: MultipleAddress,
        Address: companyDetails?.address,
        Lat: companyDetails?.lat,
        Lng: companyDetails?.lng,
        search: "",
        next_page_url: undefined,
      };
      dispatch(CustomerMiddleware.CreateCustomer(data))
        .then((data) => {
          if (data?.success) {
            dispatch(
              AlertAction.ShowAlert({ type: "success", message: data?.message })
            );
            navigate(-1);
            // Alert.alert('Note', data?.message, [
            //   { text: 'OK', onPress: () => navigation.goBack() },
            // ]);
          } else {
            if (data?.message == "You have to buy membership first.") {
              dispatch(
                AlertAction.ShowAlert({ type: "error", message: data?.message })
              );
              navigate("/subscription");
            } else {
              let dummyArray = [...MultipleAddress]
              dummyArray.splice(dummyArray?.length - 1, 1)
              setMultipleAddress(dummyArray)
              setRefresh(!Refresh)
              dispatch(
                AlertAction.ShowAlert({ type: "error", message: data?.message })
              );
            }
          }
        })
        .catch((error) => console.log(error));
    }
  };

  // const [MultipleAddress, setMultipleAddress] = useState([{
  //   id: null,
  //   address: "",
  //   state: "",
  //   zipCode : "",
  // }]);
  const onFinish = (values) => {
    // console.log('Success values:', values);
    // if (!values.email || !values.password) {
    //   dispatch(AlertAction.ShowAlert({ type: "warning", message: 'All fields required' }))
    // } else if (!values.role) {
    //   dispatch(AlertAction.ShowAlert({ type: "warning", message: 'Please select user role' }))
    // } else {
    //   dispatch(AuthMiddleware.Login(values))
    // }
  };
  const onFinishFailed = (errorInfo) => {
    // console.log('Failed:', errorInfo);
    // dispatch(AlertAction.ShowAlert({ type: "warning", message: errorInfo.message }))
  };
  const [form] = Form.useForm();
  const handleChange = (value) => {
    form.setFieldsValue({ role: value });
  };

  return (
    <div className={styles.mainCon}>
      <h1>Create New Customer</h1>
      <div className={styles.row}>
        <div className={styles.col}>
          <AntdInput
            placeholder={"First Name"}
            name={"first_name"}
            label="First Name"
            onChange={(e) => setCustomerName(e.target.value)}
            rules={[
              {
                require: true,
                type: "text",
                message: "Please enter first name",
              },
            ]}
          />
        </div>
        <div className={styles.col}>
          <AntdInput
            placeholder={"Last Name"}
            name={"last_name"}
            label="Last Name"
            onChange={(e) => setLastName(e.target.value)}
            rules={[
              {
                require: true,
                type: "text",
                message: "Please enter last name",
              },
            ]}
          />
        </div>
      </div>
      <div className={styles.row}>
        <div className={styles.col}>
          <AntdInput
            placeholder={"Email"}
            name={"email"}
            label="Email"
            onChange={(e) => setEmail(e.target.value)}
            rules={[
              {
                require: true,
                type: "email",
                message: "Please enter valid email",
              },
            ]}
          />
        </div>
        <div className={styles.col}>
          {/* <AntdInput
            placeholder={"Contact Number"}
            name={"contact_number"}
            label="Contact Number"
            onChange={(e) => setContactNumber(e.target.value)}
          /> */}
          <div className={styles.phoneInput}>
            <label>Contact Number</label>
            <PhoneInput
              className={styles.PhoneNumber}
              placeholder={"Contact Number"}
              defaultCountry="US"
              value={ContactNumber}
              maxLength={16}
              onChange={setContactNumber}
            />
          </div>
        </div>
      </div>
      <AntdDropdown
        placeholder={"Select Company"}
        name={"company"}
        label={"Company"}
        onChange={(id) => onFindCompany(id)}
        options={company}
      />
      {selectedCompanyID ?
        <div>
          <div className={styles.row}>
            <div className={styles.col}>
              <AntdInput
                placeholder={companyDetails?.name}
                disabled={true}
                name={"Company Name"}
                label="Company Name"
              // onChange={(e) => setCustomerName(e.target.value)}
              // rules={[
              //   {
              //     require: true,
              //     type: "text",
              //     message: "Please enter first name",
              //   },
              // ]}
              />
            </div>
            <div className={styles.col}>
              <AntdInput
                placeholder={companyDetails?.address}
                name={"Company Address"}
                label="Company Address"
                disabled={true}

              // onChange={(e) => setLastName(e.target.value)}
              // rules={[
              //   {
              //     require: true,
              //     type: "text",
              //     message: "Please enter last name",
              //   },
              // ]}
              />
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.col}>
              <AntdInput
                placeholder={phoneFormat(companyDetails?.contact_no)}
                name={"Company Number"}
                label="Company Number"
                disabled={true}

              // onChange={(e) => setCustomerName(e.target.value)}
              // rules={[
              //   {
              //     require: true,
              //     type: "text",
              //     message: "Please enter first name",
              //   },
              // ]}
              />
            </div>
            <div className={styles.col}>
              <AntdInput
                placeholder={companyDetails?.website}
                name={"Company Website"}
                label="Company Website"
                disabled={true}

              // onChange={(e) => setLastName(e.target.value)}
              // rules={[
              //   {
              //     require: true,
              //     type: "text",
              //     message: "Please enter last name",
              //   },
              // ]}
              />
            </div>
          </div>
        </div>
        : null}
      {/* {MultipleAddress?.length > 0 &&
        MultipleAddress?.map((item, index) => {
          return (
            <div>
              <div className={styles.row}>
                <div className={styles.col}>
                  <InputFielsAntd
                    placeholder={item?.Street}
                    // value={item?.Street}
                    label={`Address ${index + 1}`}
                    disabled={true}
                  />
                </div>
                <div className={styles.col}>
                  <InputFielsAntd
                    placeholder={item?.State}
                    // value={item?.State}
                    label="State"
                    disabled={true}
                  />
                </div>
              </div>
              <div className={styles.row}>
                <div className={styles.col}>
                  <InputFielsAntd
                    placeholder={item?.ZipCode}
                    // value={item?.ZipCode}
                    label="Zip Code"
                    disabled={true}
                  />
                </div>
                <div style={{ marginTop: "47px" }} className={styles.col}>
                  <img
                    src={minusIcon}
                    onClick={() => {
                      MultipleAddress.splice(index, 1);
                      setRefresh(!Refresh);
                    }}
                  />
                </div>
              </div>
            </div>
          );
        })} */}

      {/* <div>
        <div className={styles.row}>
          <div className={styles.col}>
            <InputFielsAntd
              placeholder={Street ? Street : "Street"}
              label="New Address"
              onChange={(e) => setStreet(e.target.value)}
              // ref={StreetRef}
              value={Street}
              ref={ref}
            />
          </div>
          <div className={styles.col}>
            <InputFielsAntd
              placeholder={State ? State : "State"}
              value={State}
              label="State"
              onChange={(e) => setState(e.target.value)}
              // ref={StateRef}
              ref={ref}
            />
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.col}>
            <InputFielsAntd
              placeholder={ZipCode ? ZipCode : "Zip Code"}
              name={"zip_code"}
              label="Zip Code"
              value={ZipCode}
              onChange={(e) => setZipCode(e.target.value)}
              // ref={ZipCodeRef}
              ref={ref}
            />
          </div>
          <div className={styles.col} style={{ marginTop: "47px" }}>
            <img src={plusIcon} onClick={onPressAddAddress} />
          </div>
        </div>
      </div> */}

      <div className={styles.row}>
        <div className={styles.col}>
          <AntdSubmit
            text={"Add Customer"}
            buttonStyle={{
              margin: "30px 0px",
              height: "60px",
              width: "100%",
            }}
            onClick={onPressCreateCustomer}
          />
        </div>
        <div className={styles.col}></div>
      </div>
      {/* </Form> */}
    </div>
  );
};
export default CreateNewCustomer;
